
import React from 'react';
import { SparklesIcon } from "lucide-react";

interface AiFilledNotificationProps {
  onReset: () => void;
}

const AiFilledNotification: React.FC<AiFilledNotificationProps> = ({ onReset }) => {
  return (
    <div className="bg-gradient-to-r from-sunset-yellow/20 to-peach-orange/10 border border-peach-orange/30 p-4 rounded-lg mb-6 flex items-center shadow-warm">
      <SparklesIcon className="h-5 w-5 text-peach-orange mr-2" />
      <p className="text-sm text-sunset-dark">
        Form filled with AI assistance. Feel free to review and edit any details before submitting.
      </p>
    </div>
  );
};

export default AiFilledNotification;
